/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeAIcon32Regular = forwardRef('MediaAudioVolumeAIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.641 3.488C20.921 2.302 23 3.21 23 4.955v22.09c0 1.744-2.078 2.653-3.359 1.467L12.608 22H7a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h5.608l7.033-6.512ZM21 4.955l-7.033 6.512a2 2 0 0 1-1.359.533H7a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h5.608a2 2 0 0 1 1.359.532L21 27.045V4.955Z" })));
});
